<template>
  <div v-if="location">
    <modal-edit-legal
      v-if="showEditLegal"
      :showModal="showEditLegal"
      :onClickCancel="hideModal"
    />

    <ui-section-header :showEdit="true" :editFunction="setShowEditLegal">
      <template v-slot:title>Legal &amp; bank</template>
    </ui-section-header>
    <table class="table is-fullwidth is-narrow is-hoverable">
      <tbody>
        <tr>
          <td>C.o.C. name</td>
          <td class="has-text-right">{{ location.CoCName }}</td>
        </tr>
        <tr>
          <td>C.o.C. number</td>
          <td class="has-text-right">{{ location.CoCNumber }}</td>
        </tr>
        <tr>
          <td>VAT number</td>
          <td class="has-text-right">{{ location.VATNumber }}</td>
        </tr>
        <tr>
          <td>Bank account number</td>
          <td class="has-text-right">{{ location.BankAccountNumber }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const ModalEditLegal = () =>
  import('@/components/Locations/ModalEditLocationLegal')

export default {
  components: {
    'modal-edit-legal': ModalEditLegal,
  },

  props: {},

  data() {
    return {
      showEditLegal: false,
    }
  },

  computed: {
    ...mapState('locationStore', ['location']),
  },

  created() {},

  methods: {
    setShowEditLegal() {
      this.showEditLegal = true
    },

    hideModal() {
      this.showEditLegal = false
    },
  },
}
</script>

<style></style>
